import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { first } from 'rxjs/operators';
import { EPermissao } from '../../models/permissao.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    // reset login status
    this.authenticationService.logout();
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.error = "";

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;

    var user = {
      email: this.f.email.value,
      password: this.f.password.value
    };

    this.authenticationService.login(user)
      .pipe(first())
      .subscribe(
        data => {

          if (this.authenticationService.canViewPermissaoUsuario({ roles: [EPermissao.Sec] })) {
            this.router.navigate(["lancamentos-faturamento"]);

          } else {
            this.router.navigate([this.returnUrl]);
          }

        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }

  cadastro() {

  }

}

